import React, {ReactNode} from "react";
import {VideoSearchResults} from "./results/VideoSearchResults";
import {VideoSearchInput} from "./input/VideoSearchInput";
import styles from "./VideoSearch.module.css";
import VideoSearchFacets from "./facets/VideoSearchFacets";
import {useSelector} from "react-redux";
import {AppState} from "../../../root/RootReducer";
import {AnimatePresence, motion} from "framer-motion";
import {CircularProgress} from "@material-ui/core";

export default function VideoSearch() {

    const {activeFacets, result, isSearching} = useSelector(({search}: AppState) => search);

    const {header} = useSelector((state: AppState) => ({
        header: state.header
    }));
    const direction = header.direction === "left" ? -1 : 1;

    return (
        <AnimatePresence>
            <motion.div
                initial={{x: 300 * direction, opacity: 0.3}}
                animate={{x: 0, opacity: 1}}
                exit={{x: -300 * direction, opacity: 0}}
                className={styles.root}
            >
                <VideoSearchInput/>

                {
                    isSearching &&
                    <div className={styles.noContent}>
                        <CircularProgress size={60} style={{color: "var(--red)"}}/>
                    </div>
                }
                {
                    !isSearching &&
                    <VideoSearchBody>
                        {
                            result?.aggregationGroups &&
                            <VideoSearchFacets
                                aggs={result?.aggregationGroups}
                                activeAggregations={activeFacets}
                            />
                        }

                        <VideoSearchResults hits={result?.searchHits}/>
                    </VideoSearchBody>
                }
            </motion.div>
        </AnimatePresence>
    );
}

function VideoSearchBody({children}: {children: ReactNode}) {
    return (
        <div className={styles.body}>{children}</div>
    );
}
